import { jsx as _jsx } from "react/jsx-runtime";
import { getMentionOnSelectItem } from '@udecode/plate-mention';
import { PlateElement, withRef } from '@udecode/plate/react';
import { useRef } from 'react';
import { useMentionContext } from './MentionContext';
import { MENTION_END_CHAR_REGEX, MENTION_TRIGGER } from './mentionUtils';
import { StyledMention } from './styled';
import { TriggerInputElement } from './TriggerInputElement';
const onSelectItem = getMentionOnSelectItem();
export const MentionInputElement = withRef(({ ...props }, ref)=>{
    const { editor } = props;
    const { editorContainerRef, getMentionSuggestions, renderMentionSuggestion, getMentionValue: getMentionValueFromContext, onMentionTrigger, onMentionSelect, onMentionHover } = useMentionContext();
    const lastHoveredSuggestionRef = useRef(undefined);
    const onSelect = (suggestion, search)=>{
        if (suggestion) {
            onMentionSelect?.(suggestion);
            const text = getMentionValueFromContext ? getMentionValueFromContext(suggestion) : suggestion.value;
            if (text && text.trim() !== '') {
                onSelectItem(editor, {
                    text: `${MENTION_TRIGGER}${text} `
                }, search);
            }
        } else if (search?.trim() && search !== MENTION_TRIGGER) {
            onSelectItem(editor, {
                text: `${search} `
            }, search);
        }
    };
    const _onMentionHover = (suggestion)=>{
        if (lastHoveredSuggestionRef.current && lastHoveredSuggestionRef.current.value === suggestion?.value) return;
        onMentionHover?.(suggestion);
        lastHoveredSuggestionRef.current = suggestion;
    };
    return /*#__PURE__*/ _jsx(TriggerInputElement, {
        ref: ref,
        ...props,
        trigger: MENTION_TRIGGER,
        getSuggestions: getMentionSuggestions,
        renderSuggestion: renderMentionSuggestion,
        onSelect: onSelect,
        onTrigger: onMentionTrigger,
        onActiveOptionChange: _onMentionHover,
        endCharRegex: MENTION_END_CHAR_REGEX,
        editorContainerRef: editorContainerRef,
        dataTestId: "mention-autocomplete"
    });
});
export const MentionElement = withRef(({ ...props }, ref)=>{
    const { renderMention } = useMentionContext();
    const element = props.element;
    const cleanedMention = element.value.slice(1);
    if (!cleanedMention) return null;
    return /*#__PURE__*/ _jsx(PlateElement, {
        ref: ref,
        as: "span",
        ...props,
        children: renderMention ? renderMention(cleanedMention, MENTION_TRIGGER) : /*#__PURE__*/ _jsx(StyledMention, {
            children: element.value
        })
    });
});
